<script lang="ts">
  import {LuckyWheel, LuckyGrid} from "lucky-canvas";
  import {onMount} from "svelte";
  import {toasts} from "$lib/stores/toastStores";
  import {userService} from "$lib/services/user.service";
  import TicketIcon from "$lib/icons/TicketIcon.svelte";
  import {translate} from "$lib/i18n";
  import {dialogData} from "$lib/stores/dialogStores";

  let spinLucky!: HTMLDivElement = $state();
  let prizes = [
    {fonts: [{ text: '1000 TRON', top: '0%', fontSize: '0px', fontColor: 'transparent'},]},
    {fonts: [{ text: '100 €', top: '10%', fontSize: '0px', fontColor: 'transparent'},]},
    {fonts: [{ text: '1 USDT', top: '10%', fontSize: '0px', fontColor: 'transparent'},]},
    {fonts: [{ text: '5 $', top: '10%', fontSize: '0px', fontColor: 'transparent'},]},
    {fonts: [{ text: '10 FS', top: '10%', fontSize: '0px', fontColor: 'transparent'},]},
    {fonts: [{ text: '0.0002 BTC', top: '10%', fontSize: '0px', fontColor: 'transparent'},]},
    {fonts: [{ text: '0.003 ETH', top: '10%', fontSize: '0px', fontColor: 'transparent'},]},
    {fonts: [{ text: '1 €', top: '10%', fontSize: '0px', fontColor: 'transparent'},]},
    {fonts: [{ text: '30 USDT', top: '10%', fontSize: '0px', fontColor: 'transparent'},]},
    {fonts: [{ text: '20 £', top: '10%', fontSize: '0px', fontColor: 'transparent'},]},
    {fonts: [{ text: '200 FS', top: '10%', fontSize: '0px', fontColor: 'transparent'},]},
    {fonts: [{ text: '100K', top: '10%', fontSize: '0px', fontColor: 'transparent'},]},
  ]
  let tickets = $state(0);

  onMount(() => {
    dialogData.subscribe(value => {
      if (value.WheelSpinModal) {
        tickets = Number(value.WheelSpinModal);
      }
    });
    const myLucky = new LuckyWheel(spinLucky, {
      width: '380px',
      height: '380px',
      blocks: [
        { padding: '20px', background: '#191D25',
          imgs: [{
            src: '/wheel/wheel-border-1.webp',
            width: '100%',
          }]
        },
        { padding: '5px',
          imgs: [{
            src: '/wheel/wheel-circle.webp',
            width: '100%',
          }]
        },
        {
          padding: '20px',
          imgs: [{
            src: '/wheel/wheel-block.png',
            width: '100%',
            rotate: true
          }]
        }
      ],
      buttons: [
        {
          radius: '45%',
          pointer: true,
          imgs: [{
            src: '/wheel/spin-btn.png',
            width: '80%',
            top: '-80%',
          },{
            src: '/wheel/arrow.png',
            width: '58px',
            top: '-45%',
            left: '255%',
          }]
        }
      ],
      prizes: prizes,
      defaultConfig: {
        offsetDegree: 15,
        speed: 2,
        accelerationTime: 1000,
        decelerationTime: 1000,
      },
      start: () => {
        if (tickets < 1) {
          toasts.send('You have no tickets left', 'warning')
          return
        }
        userService.claimBonusByType('SPINNER').then((res: any) => {
          if (res.error) {
            toasts.send(res.error, 'warning')
            return
          }
          myLucky.play()
          tickets -= 1;
          let stopWheelIndex = prizes.findIndex((prize) => prize.fonts[0].text === res.data.data.label);
          setTimeout(() => {
            myLucky.stop(stopWheelIndex);
          }, 5000)
        }, (err: any) => {
          toasts.send('You have no tickets left', 'warning')
        })
      },
      end: (prize: any) => {
        toasts.send('You won ' + prize.fonts[0].text, 'success')
      }
    })
    if (myLucky.isWeb()) {

    }

  })

</script>

<div class="spin-wheel-container text-center">
  <div bind:this={spinLucky} id="my-lucky"></div>
  <div class="relative select-none h-10">
    <img class="absolute -bottom-16" src="/wheel/forza-spin-banner-elemnt.png" >
  </div>
  <div class="flex justify-center">
    <div class="border-2 border-primary-lightBlue rounded-xl py-2 px-4 text-white mt-3 flex items-center justify-center gap-2">
      <TicketIcon css="fill-primary-yellow  w-8 h-8" />
      {$translate('Tickets:')} {tickets}
    </div>
  </div>
</div>
